import React, { useContext, useEffect, useState } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { Layout } from "antd"

import { PHMenu } from "@/components/PHMenu"
import { MenuItemType } from "@/components/PHMenu/MenuType"
import { UserContext } from "@/contexts/SessionContext"
import { ThemeContext } from "@/contexts/ThemeContext"
import { SolutionOutlined } from "@ant-design/icons"
import { PHSearchInput } from "@/components/PHSearchInput"
import { PHHeaderDropdown } from "../PHHeaderDropdown"
import { menuList as rawMenuList } from "./MenuData"
import styles from "./PHLayout.module.less"

const { Header, Content, Sider } = Layout

export const PHLayout = ({
  customerId,
  children
}: {
  customerId?: string
  children: React.ReactNode
}): JSX.Element => {
  const { theme } = useContext(ThemeContext)
  const { session } = useContext(UserContext)
  const [menuList, setMenuList] = useState([])
  const location = useLocation()
  const [selectedKeys, setSelectedKeys] = useState([])
  const [keyWord, setKeyWord] = useState("")
  const history = useHistory()

  useEffect(() => {
    const index = menuList.findIndex((item: MenuItemType) => {
      return item.routeExp?.test(location.pathname)
    })
    setSelectedKeys(menuList[index]?.keyPath)
  }, [menuList, location.pathname])

  useEffect(() => {
    if (session?.user?.roles) {
      const list = rawMenuList.filter((item) => {
        return item.roles.filter((x) => session.user.roles.indexOf(x) >= 0).length > 0
      })
      setMenuList(list)
    }
  }, [session])

  const handleSearch = (val: string): void => {
    if (val !== "") {
      setKeyWord(keyWord)
      history.push({
        pathname: `/customers/${customerId}/predictions/search`,
        search: new URLSearchParams({ searchText: val.trim() }).toString()
      })
    }
  }

  return (
    <Layout className={`${styles["ph-layout"]} ${theme === "dark" ? "dark" : ""}`}>
      <Sider
        theme={theme}
        className={styles["ph-sider"]}
        breakpoint="xl"
        collapsedWidth="0"
        width="210px"
      >
        <PHMenu list={menuList} selectedKeys={selectedKeys} />
      </Sider>
      <Layout className={styles["ph-content"]}>
        <Header className={styles["ph-header"]}>
          <div className={styles["ph-global-prediction-search"]}>
            <PHSearchInput
              phSearchInputProps={{
                key: keyWord,
                defaultValue: keyWord,
                placeholder: "Search predictions by name/email/id",
                onSearch: handleSearch
              }}
            />
          </div>
          <div className={styles["session-box"]}>
            <span className={styles["current-customer"]}>
              <SolutionOutlined /> {session?.currentCustomer?.customerName}
            </span>
            <PHHeaderDropdown />
          </div>
        </Header>
        <Content>
          <div className={styles.content}>{children}</div>
        </Content>
      </Layout>
    </Layout>
  )
}

export default PHLayout
